namespace Solovis.UI.Tooltip {

    /*
     * Options:
     *  Name        Required    Type            Default         Description                                     
     *  element     true        DOM element                     Html element to which the tooltip is attached
     * 
     *  text                    string |                        The text of the tooltip or a function that returns a string
     *                          function                         
     * 
     *  html                    string |                        The html of the tooltip or a function that returns html.  Overrides text.
     *                          function                       
     * 
     *  delay                   number |        {               Delay showing and hiding the tooltip (ms)
     *                          object            show: 400,    If a number is supplied, delay is applied to both hide/show   
     *                                            hide: 100     
     *                                          }                 
     * 
     *  placement               string          "top"           How to position the tooltip - top | bottom | left | right | auto.
     *                                                          When "auto" is specified, it will dynamically reorient the tooltip. For example, if 
     *                                                          placement is "auto left", the tooltip will display to the left when possible, 
     *                                                          otherwise it will display right.
     *                                                          
     *  trigger                 string          "hover focus"   How tooltip is triggered - click | hover | focus. You may pass multiple 
     *                                                          triggers; separate them with a space.
     */

    export interface TooltipCreateOptions {
        element: JQuery;
        text: any;
        html: any;
        delay: number | { show?: number; hide?: number };
        placement: string;
        trigger: string;
    }

    export function create(options: TooltipCreateOptions): void {
        if (!options.element) {
            throw "Missing parameter: element";
        }
        if (!options.text && !options.html) {
            throw "Missing parameter: text or html";
        }

        var tooltipOptions = {
            title: options.html ? options.html : options.text,
            delay: Solovis.isNotNull(options.delay) ? options.delay : { show: 400, hide: 100 },
            html: options.html ? true : false,
            placement: options.placement,
            trigger: options.trigger,
            container: "body"
        };

        (options.element as any).tooltip(tooltipOptions);
    }


    export function destroyTooltipOnElement(element: JQuery): void {
        (element as any).tooltip("destroy");
    }

}